// 参与 hreflang 互指的分类页 url_key 白名单。
// 只有各国站点都存在的分类才列在这里 —— 指向不存在的页面会让 Google 忽略整组 hreflang。
export const HREFLANG_CATEGORY_URL_KEYS = [
  'bridesmaid-dresses',
  'long-bridesmaid-dresses',
  'short-bridesmaid-dresses',
  'floral-bridesmaid-dresses',
  'convertible-bridesmaid-dresses',
  'plus-size-dresses',
  'maternity-bridesmaid-dresses',
  'junior-bridesmaid-dresses',
  'swatches',
  'shop-by-fabric',
  'free-moodboard',
  'real-wedding',
  'size-chart',
  'wedding-dresses',
  'plus-size-wedding-dresses',
  'little-white-dresses',
  'floral-wedding-dresses',
  'convertible-wedding-dresses',
  'boho-wedding-dresses',
  'beach-wedding-dresses',
  'wedding-guest-dresses',
  'black-tie-wedding-guest-dresses',
  'spring-wedding-guest-dresses',
  'plus-size-wedding-guest-dresses',
  'casual-wedding-guest-dresses',
  'cocktail-wedding-guest-dresses',
  'beach-wedding-guest-dresses',
  'garden-wedding-guest-dresses',
  'country-wedding-guest-dresses',
  'summer-wedding-guest-dresses',
  'autumn-wedding-guest-dresses',
  'fall-wedding-guest-dresses',
  'winter-wedding-guest-dresses',
  'mother-of-the-bride-dresses',
  'spring-mother-of-the-bride-dresses',
  'mother-of-the-bride-dresses-with-wraps',
  'dresses',
  'floral-dresses',
  'reborn-collection-dresses',
  'prom-dresses',
  'homecoming-dresses',
  'graduation-dresses',
  'formal-dresses',
  'fabrics',
  'wedding-sales',
  'bridesmaid-dresses-sale',
  'wedding-dresses-sale',
  'holiday-dresses',
  'party-dresses',
  'evening-dresses',
];
